import React, { useState, useEffect, useMemo } from 'react';
import {isBrowser, isDesktop, isMobile} from 'react-device-detect';
import BotoExportar from './botons/BotoExportar';
import BotoUndo from './botons/BotoUndo';
import LlistaCastellers from './LlistaCastellers';
import resetPersonSelection from './resetPersonSelection';
import useTypeToSearch from './useTypeToSearch';
import { searchMatches, sortMatches } from './castellerSearch';
import './Controller.css'

import { fetchAPI } from '../../../utils/utils';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import BotoAssistencia from './botons/BotoAssistencia';
import BotoAjuntament from './botons/BotoAjuntament';
import AjuntamentModal from './AjuntamentModal';
import LlistaAssistencies from '../../interface/assistencia/LlistaAssistencies';
import BotoChat from './botons/BotoChat';
import ChatPopup from '../../chat/ChatPopup';
import BotoPestanyaUp from './botons/BotoPestanyaUp';
import BotoPestanyaDown from './botons/BotoPestanyaDown';
import BotoImportar from './botons/BotoImportar';
import { applyChange } from '../../../utils/loadPositions';
import { recordRedDeleteAndMaybePromptByUserId } from '../utils/redDeleteTracker';

const saveChange = (props) => {
    const {
        socket,
        castellerSelected,
        caixaSelected,
        posicions,
        nextChangeFromSuggestion,
        setNextChangeFromSuggestion,
    } = props;

    if (Number(castellerSelected) < 0) return;

    const room = `${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`;
    const action_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const fromSuggestion = !!nextChangeFromSuggestion;

    // If casteller was already in a caixa, remove it
    if (castellerSelected in posicions.castellers) {
        const prevCaixa = posicions.castellers[castellerSelected];
        applyChange(props, `${prevCaixa},_EMPTY_`);
        socket.emit('.save_change_to_room', room, `${prevCaixa},_EMPTY_`, action_id, fromSuggestion);
    }

    // Apply change locally first
    applyChange(props, `${caixaSelected},${castellerSelected}`);
    // Emit change to server-side (bounces to all users)
    socket.emit('.save_change_to_room', room, `${caixaSelected},${castellerSelected}`, action_id, fromSuggestion);

    setNextChangeFromSuggestion(false);
};

const erasePosition = (props) => {
    const { socket, caixaSelected, setCaixaSelected, posicions, assistenciesEvent } = props;
    const room = `${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`;
    const action_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    const deletedUserId = posicions?.caixes?.[caixaSelected];

    if (Number(props.castellersInfo?.[deletedUserId]?.is_temporary) === 1) {
        props.removeTemporaryPerson(deletedUserId);
        return;
    }

    applyChange(props, `${caixaSelected},_EMPTY_`);
    socket.emit('.save_change_to_room', room, `${caixaSelected},_EMPTY_`, action_id);
    setCaixaSelected(-1);

    // Track consecutive 'No vinc' deletions and maybe prompt
    recordRedDeleteAndMaybePromptByUserId(deletedUserId, assistenciesEvent, props);
};

const confirmatsFilter = casteller => (casteller["assistència"] === 1 || casteller["assistència"] === 2)
const noConfirmatsFilter = casteller => casteller["assistència"] !== 0 && casteller["assistència"] !== 1 && casteller["assistència"] !== 2
const noVenenFilter = casteller => casteller["assistència"] === 0
const canallaFilter = casteller  => parseInt(casteller.canalla) === 1
const novellFilter = casteller => parseInt(casteller?.novell) === 1
const amagatFilter = casteller => parseInt(casteller.hidden) === 1

function Controller(props) {
    const { setImporting, setLastLlista, assistenciesEvent, isModel, tabs, pestanya, setPestanya, socket, extended, setExtended, ajuntament, setAjuntament, castellerSelected, posicions, lastCaixes, caixaSelected, swiper, setSwiper, castell, hoveredUser, setHoveredUser, copilotSuggestion, acceptCopilotSuggestion, dismissCopilotSuggestion, castellersInfo, openLlista } = props;

    const [popupAssistsClosed, setPopupAssistsClosed] = useState(true);
    const [popupChatClosed, setPopupChatClosed] = useState(true);

    const [nameSearch, setNameSearch] = useState('')
    const [showBuscar, setShowBuscar] = useState(false)
    const [isFocused, setIsFocused] = useState(false)
    useTypeToSearch({ caixaSelected, setNameSearch, setShowBuscar, openLlista });

    const [etiquetes, setEtiquetes] = useState([]);
    const [etiquetaUsers, setEtiquetaUsers] = useState([]);

    const [activeSlide, setActiveSlide] = useState(false);

    const castellers = useMemo(() => 
        Object.values(props.assistenciesEvent || {})
            // Don't show hidden
            .filter(c => (nameSearch === '' && props.name !== 'amagats') ? (parseInt(c.hidden) !== 1 || [1, 2].includes(c['assistència'])) : true)
            // Filtrar per nom
            .filter(casteller => searchMatches(casteller, nameSearch))
            // Sort remaining
            .sort((a, b) => a.altura > b.altura ? 1 : -1)
            // Sort matches if searching
            .sort((a, b) => nameSearch !== '' ? (sortMatches(a, nameSearch) > sortMatches(b, nameSearch) ? 1 : -1) : 0)
    , [props.assistenciesEvent, nameSearch]);

    useEffect(() => {
        setSwiper(new Swiper(".controllerSwiper", {
            threshold: 20,
            initialSlide: 0,
            allowTouchMove: true,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        }));
    }, []);

    useEffect(() => {
        if (swiper) {
            swiper.on('transitionStart', function() {
                // If slide is not 0, extend
                setExtended(swiper.realIndex > 0)

                // Set active slide
                setActiveSlide(swiper.realIndex)

                // Aesthetic change
                setTimeout(
                    () => {
                        document.querySelector('.activa')?.classList.remove('activa')
                        document.querySelector('.swiper-slide.swiper-slide-active').querySelector('.castellers-container')?.classList.add('activa')
                    },
                    50
                )
            });

            swiper.on('transitionEnd', function() {
                if (swiper.realIndex > 0) {
                    setLastLlista(swiper.realIndex)
                }
            });
        }
    }, [swiper])

    useEffect(() => {
        fetchAPI('/etiquetes', setEtiquetes)
    }, [])

    useEffect(() => {
        etiquetes.forEach(etiqueta => {
            fetchAPI(
                `/etiqueta_users/${etiqueta.id}`,
                users => setEtiquetaUsers(
                    prev => ({
                        ...prev,
                        [etiqueta.id]: {
                            castellers: users,
                            perfil: etiqueta.nom
                        }
                    })
                )
            )
        })
    }, [
        etiquetes
    ])

    const handleKeyDown = (e) => {
        if (document.querySelector('dialog[open], [data-board-confirmation]')) return;
        if (e.target.closest?.('button, input, select, textarea, [role="button"]')) return;
        if (isFocused) return;
        if (isMobile) return;

        if (extended && caixaSelected !== -1) {
            // If key is backspace, remove last letter from nameSearch
            if (e.key === 'Backspace') {
                setNameSearch(prev => prev.slice(0, -1))
            }
            // If key is enter, search for casteller or accept copilot suggestion
            else if (e.key === 'Enter') {
                if (nameSearch !== '') {
                    const castellers = document.querySelectorAll('.castellers-container.activa .casteller');
                    const castellersArray = Array.from(castellers);
                    const casteller = castellersArray?.[0]

                    if (casteller) {
                        casteller.click();
                    }
                } else if (
                    copilotSuggestion &&
                    String(copilotSuggestion.caixaId) === String(caixaSelected)
                ) {
                    acceptCopilotSuggestion('desktop_enter');
                }
            }
            // If key is escape, close search
            else if (e.key === 'Escape') {
                resetPersonSelection({ ...props, setNameSearch, setShowBuscar, setIsFocused });
            }
        }

        if (caixaSelected !== -1) {
            // If key is delete, remove casteller from caixa
            if (e.key === 'Delete') {
                erasePosition(props);
            }
        }
    }

    useEffect(() => {
        document.addEventListener('keyup', handleKeyDown)

        return () => {
            document.removeEventListener('keyup', handleKeyDown)
        }
    }, [extended, caixaSelected, isFocused, nameSearch, copilotSuggestion, acceptCopilotSuggestion, castellersInfo, posicions, props.removeTemporaryPerson]);

    useEffect(() => {
        if (castellerSelected > -1 && caixaSelected !== -1) {
            saveChange(props);
            resetPersonSelection({ ...props, setNameSearch, setShowBuscar, setIsFocused });
        }
    }, [castellerSelected, caixaSelected]);

    useEffect(() => {
        const caixaEmpty = !(caixaSelected in posicions.caixes);

        const areSame = lastCaixes.prev === lastCaixes.current;
        const areBothCaixes = lastCaixes.prev !== -1 && lastCaixes.current !== -1;
        const prevHadAssigned = lastCaixes.prev in posicions.caixes;
        const possibleSwap = !areSame && areBothCaixes && prevHadAssigned;

        if (caixaSelected !== -1 && caixaEmpty && !possibleSwap) {
            setExtended(true)
            openLlista?.();
        } else {
            // setExtended(false)
            // if (swiper) swiper.slideTo(0, 0);
        }
    }, [lastCaixes]);

    const nNovells = Object
        .values(props.castellersInfo)
        .filter(novellFilter)
        .length;

    const filterFamilies = (c) => c.casteller === 0 && c.music === 0

    const mobileSuggestedId =
        isMobile &&
        caixaSelected !== -1 &&
        copilotSuggestion &&
        String(copilotSuggestion.caixaId) === String(caixaSelected)
            ? parseInt(copilotSuggestion.suggestedCastellerId, 10)
            : NaN;
    const mobileSuggestedInfo = !Number.isNaN(mobileSuggestedId) ? castellersInfo?.[mobileSuggestedId] : null;
    const mobileSuggestedName = mobileSuggestedInfo
        ? (mobileSuggestedInfo.mote || mobileSuggestedInfo.nom || '')
        : null;
    const mobileSuggestedAltura = mobileSuggestedInfo?.altura;

    return (
        <>
            <LlistaAssistencies noInfo withTarget targetOnly={isModel} etiquetes={etiquetes} etiquetaUsers={etiquetaUsers} setEtiquetaUsers={setEtiquetaUsers} assistencies={assistenciesEvent || []} popupClosed={popupAssistsClosed} setPopupClosed={setPopupAssistsClosed} event={props.selectedEvent} {...props} />
            <ChatPopup popupClosed={popupChatClosed} setPopupClosed={setPopupChatClosed} {...props} />
            {!isModel ? <AjuntamentModal {...props} closed={props.ajuntamentModalClosed} setClosed={props.setAjuntamentModalClosed} room={`${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`} /> : null}

            { mobileSuggestedName && (
                <div className="copilot-mobile-bar">
                    <span className="copilot-mobile-name">
                        {mobileSuggestedName}
                        {!isNaN(mobileSuggestedAltura) && mobileSuggestedAltura != null && (
                            <span className="copilot-mobile-altura">{mobileSuggestedAltura}</span>
                        )}
                    </span>
                    <div className="copilot-mobile-actions">
                        <button
                            className="copilot-btn copilot-btn-accept"
                            onClick={() => acceptCopilotSuggestion('mobile_button')}
                        >
                            Acceptar
                        </button>
                        <button
                            className="copilot-btn copilot-btn-ignore"
                            onClick={() => dismissCopilotSuggestion('mobile_button')}
                        >
                            Ignorar
                        </button>
                    </div>
                </div>
            )}

            <div id="controller-container" className={`swiper controllerSwiper ${extended ? 'extended' : ''}`}>
                <div className="swiper-wrapper">
                    <div className="swiper-slide botons">
                        <BotoUndo room={`${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`} {...props} />
                        <BotoImportar setImporting={setImporting} />
                        {isBrowser && !isModel && <BotoExportar {...props} />}
                        <BotoAssistencia setPopupClosed={setPopupAssistsClosed} {...props} />
                        {!isModel && <BotoAjuntament ajuntament={ajuntament} {...props} />}
                        {/* { isBrowser && <BotoChat setPopupClosed={setPopupChatClosed} {...props} /> } */}
                        <BotoPestanyaUp full={false} tabs={tabs} pestanya={pestanya} setPestanya={setPestanya} {...props} />
                        <BotoPestanyaDown full={false} tabs={tabs} pestanya={pestanya} setPestanya={setPestanya} {...props} />
                    </div>

                    {
                        !isModel ? <>
                            <div className="swiper-slide llista-container castellers-confirmats">
                                <LlistaCastellers isModel={isModel} slideNum={1} name="etiquetes" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={confirmatsFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>
                            <div className="swiper-slide llista-container castellers-confirmats">
                                <LlistaCastellers isModel={isModel} slideNum={2} name="confirmats" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={confirmatsFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>
                            <div className="swiper-slide llista-container castellers-no-confirmats">
                                <LlistaCastellers slideNum={3} name="no confirmats" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={noConfirmatsFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>

                            <div className="swiper-slide llista-container castellers-no-venen">
                                <LlistaCastellers slideNum={4} name="no venen" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={noVenenFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>

                            <div className="swiper-slide llista-container castellers-canalla">
                                <LlistaCastellers slideNum={5} name="canalla" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={canallaFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>

                            <div className="swiper-slide llista-container castellers-altres">
                                <LlistaCastellers slideNum={6} name="famílies" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={filterFamilies} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>

                            <div className="swiper-slide llista-container castellers-amagats">
                                <LlistaCastellers slideNum={7} name="amagats" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={amagatFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>
                        </> : <>
                            <div className="swiper-slide llista-container castellers-confirmats">
                                <LlistaCastellers isModel={isModel} slideNum={1} name="etiquetes" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={confirmatsFilter} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>
                            <div className="swiper-slide llista-container castellers-tots">
                                <LlistaCastellers isModel={isModel} slideNum={2} name="tots" etiquetaUsers={etiquetaUsers} etiquetes={etiquetes} filter={() => true} {...props} nameSearch={nameSearch} setNameSearch={setNameSearch} showBuscar={showBuscar} setShowBuscar={setShowBuscar} isFocused={isFocused} setIsFocused={setIsFocused} json={props.json} castellers={castellers} hoveredUser={hoveredUser} setHoveredUser={setHoveredUser} />
                            </div>
                        </>
                    }
                </div>

                {
                    !showBuscar && isDesktop && swiper?.realIndex > 0 &&
                    <>
                        <div onClick={() => swiper?.slidePrev(0)} className="swiper-button-prev"></div>
                        <div onClick={() => swiper?.slideNext(0)} className="swiper-button-next"></div>
                    </>
                }
            </div>
        </>
    );
}

export default Controller;
